var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageButtonGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.54 12.2585C22.54 11.4431 22.4668 10.659 22.3309 9.90625H11.5V14.3547H17.6891C17.4225 15.7922 16.6123 17.0101 15.3943 17.8256V20.711H19.1109C21.2855 18.709 22.54 15.7608 22.54 12.2585Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4995 23.5025C14.6045 23.5025 17.2077 22.4727 19.1104 20.7164L15.3938 17.8309C14.364 18.5209 13.0467 18.9286 11.4995 18.9286C8.50425 18.9286 5.96902 16.9057 5.0647 14.1875H1.22266V17.167C3.11493 20.9255 7.00402 23.5025 11.4995 23.5025Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06523 14.1855C4.83523 13.4955 4.70455 12.7584 4.70455 12.0005C4.70455 11.2425 4.83523 10.5055 5.06523 9.81548V6.83594H1.22318C0.444318 8.38844 0 10.1448 0 12.0005C0 13.8562 0.444318 15.6125 1.22318 17.165L5.06523 14.1855Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4995 5.07386C13.1879 5.07386 14.7038 5.65409 15.8956 6.79364L19.194 3.49523C17.2024 1.63955 14.5992 0.5 11.4995 0.5C7.00402 0.5 3.11493 3.07705 1.22266 6.83545L5.0647 9.815C5.96902 7.09682 8.50425 5.07386 11.4995 5.07386Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageButtonGoogle);
export default __webpack_public_path__ + "static/media/landingPageButtonGoogle.9a2c5214787a03260b65af8e08ae37ab.svg";
export { ForwardRef as ReactComponent };